import Dexie from 'dexie';
import 'dexie-observable';
import 'dexie-syncable';
import {loginApi,api,baseUrl} from '../config.jsx'



const syncFunction =(context, url, options, baseRevision, syncedRevision, changes, partial, applyRemoteChanges, onChangesAccepted, onSuccess, onError) =>
{
        /// <param name="context" type="IPersistedContext"></param>
        /// <param name="url" type="String"></param>
        /// <param name="changes" type="Array" elementType="IDatabaseChange"></param>
        /// <param name="applyRemoteChanges" value="function (changes, lastRevision, partial, clear) {}"></param>
        /// <param name="onSuccess" value="function (continuation) {}"></param>
        /// <param name="onError" value="function (error, again) {}"></param>

        var POLL_INTERVAL = options.pollInterval ? options.pollInterval : 10000; // Poll every 10th second

        // In this example, the server expects the following JSON format of the request:
        //  {
        //      [clientIdentity: unique value representing the client identity. If omitted, server will return a new client identity in its response that we should apply in next sync call.]
        //      baseRevision: baseRevision,
        
        //      partial: partial,
        //      changes: changes,
        //      syncedRevision: syncedRevision
        //  }
        //  To keep the sample simple, we assume the server has the exact same specification of how changes are structured.
        //  In real world, you would have to pre-process the changes array to fit the server specification.
        //  However, this example shows how to deal with ajax to fulfil the API.
        var request = {
            clientIdentity: context.clientIdentity || null,
            baseRevision: baseRevision,
            partial: partial,
            changes: changes,
            syncedRevision: syncedRevision
        };
        // check if  server rechable to prevent preflight cors exception, when POST is coming
        // this fetch is without auth, so there will be no pre-fleight and it shoud terminate properly

       
        try
        {

            // Send the request:
            let paras= {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...options.fetchOptions
                    },
                body: JSON.stringify(request).replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029')
            }
            
            fetch(url, paras)
            .then((data)=>
            {
                if(!data)
                {

                        onError('sync fetch no data', POLL_INTERVAL);

                }
                else if(data.status>=300)
                {
                    console.error('sync status',data.status)
                    onError('sync gave status '+data.status, POLL_INTERVAL);
                    return {}
                }

                else
                {
                    return data.json()
                }
            })
            .then
            (
                (data)=> {
                    // In this example, the server response has the following format:
                    //{
                    //    success: true / false,
                    //    errorMessage: "",
                    //    changes: changes,
                    //    currentRevision: revisionOfLastChange,
                    //    needsResync: false, // Flag telling that server doesn't have given syncedRevision or of other reason wants client to resync. 
                    //              ATTENTION: this flag is currently ignored by Dexie.Syncable
                    //    partial: true / false, // The server sent only a part of the changes it has for us. On next resync it will send more based on the clientIdentity
                    //    [clientIdentity: unique value representing the client identity. Only provided if we did not supply a valid clientIdentity in the request.]
                    //}
                    if(!data)
                    {
                        // most likely no connection
                    }
                    else if (!data.success) {
                        alert('Synchronisationsfehler Fehlermeldung: '+data.errorMessage)
                        if(data.errorNo===401)
                            window.location.href='/RegisterScan'
                        onError (data.errorMessage, Infinity); // Infinity = Don't try again. We would continue getting this error.
                    } else {
                        if ('clientIdentity' in data) {
                            context.clientIdentity = data.clientIdentity;
                            // Make sure we save the clientIdentity sent by the server before we try to resync.
                            // If saving fails we wouldn't be able to do a partial synchronization
                            context.save()
                                .then(() => {
                                    // Since we got success, we also know that server accepted our changes:
                                    onChangesAccepted();
                                    // Convert the response format to the Dexie.Syncable.Remote.SyncProtocolAPI specification:
                                    applyRemoteChanges (data.changes, data.currentRevision, data.partial, data.needsResync);
                                    onSuccess({ again: POLL_INTERVAL });
                                })
                                .catch((e) => {
                                    // We didn't manage to save the clientIdentity stop synchronization
                                    onError(e, Infinity);
                                });
                        } else {
                            // Since we got success, we also know that server accepted our changes:
                            onChangesAccepted();
                            // Convert the response format to the Dexie.Syncable.Remote.SyncProtocolAPI specification:
                            applyRemoteChanges (data.changes, data.currentRevision, data.partial, data.needsResync);
                            onSuccess({ again: POLL_INTERVAL });
                        }
                    }
                }
            )
            .catch(
                function (error) {
                // Network down, server unreachable or other failure. Try again in POLL_INTERVAL seconds.
            
                    onError(error.message, POLL_INTERVAL);
            
            })
        }              
        catch(e){console.log (e)}

}

Dexie.Syncable.registerSyncProtocol("sabine", {

    sync: syncFunction
});
